<template>
    <el-dialog title="创建质检单" :visible.sync="createQualityListFlag" :destroy-on-close="true" width="30%" top="70px"
        style="text-align: center">
        <el-form ref="createQualityListForm" :model="addForm" :rules="formRules" label-width="120px">
            <el-form-item label="参考单号：" prop="signForNumber">
                <el-input v-model="addForm.signForNumber" :disabled='sourceType == "10" || sourceType == "20"'></el-input>
            </el-form-item>
            <el-form-item label="收货箱数：" prop="receivedBoxCount">
                <el-input v-model="addForm.receivedBoxCount" placeholder="请输入关联单号" disabled></el-input>
            </el-form-item>
            <el-form-item label="质检方式：" prop="checkType">
                <el-select v-model="addForm.checkType" placeholder="请选择质检方式" style="width: 100%;">
                    <el-option v-for="item in checkTypeList" :label="item.label" :value="item.value"
                        :key="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="addForm.remark">
                </el-input>
            </el-form-item>
            <div class="noMarginBottom">
                <el-button @click.native="createQualityListFlag = false" :loading="addLoading">取消</el-button>
                <el-button type="primary" @click="onSubmit(10)" :loading="addLoading">提交</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
  
<script>
import {
    InsertQCCheckInfo
} from "@/api/QCCheck/index.js";
import { GetCurrencyServiceModelList } from "@/api/common/common.js";
import { arrToJoin, toSelectOptions, getSearchDataIndex } from "util/util";
export default {
    props: ['sourceType'],
    data() {
        return {
            checkTypeList: [
                {
                    label: '全检',
                    value: 10
                },
                {
                    label: '抽检',
                    value: 20
                }
            ],
            currencyList: [],
            feeTypeList: [],
            addForm: {},
            createQualityListFlag: false,
            addLoading: false,
            expensesList: [],
            formRules: {
                signForNumber: [{ required: true, message: "请输入参考单号", trigger: "blur" }],
                checkType: [{ required: true, message: "请选择质检方式", trigger: "blur" }],
            },
        };
    },
    methods: {
        showDalog(data) {
            // 设置增值服务类型下拉
            if (this.sourceType == 20) {
                let { signForNumber, receivedBoxCount, tfSignForID } = data
                this.addForm = {
                    signForNumber,
                    sourceID: tfSignForID,
                    receivedBoxCount
                }
            } else {
                let { putOnNo, qty, putOnInfoID } = data
                this.addForm = {
                    signForNumber: putOnNo,
                    sourceID: putOnInfoID,
                    receivedBoxCount: qty
                }
            }
            this.createQualityListFlag = true
        },
        onSubmit(status) {
            this.$refs.createQualityListForm.validate((valid) => {
                if (valid) {
                    let params = Object.assign({}, this.addForm);
                    this.addLoading = true;
                    params.sourceType = this.sourceType  // 新增、提交状态码
                    InsertQCCheckInfo(params).then((res) => {
                        this.addLoading = false;
                        if (res.data.success) {
                            this.$refs["createQualityListForm"].resetFields();
                            this.$message({
                                message: res.data.msg || "操作成功",
                                type: "success",
                            });
                            this.createQualityListFlag = false;
                            this.$emit("searchTable", "");
                        } else {
                            this.$message({
                                message: res.data.msg || "操作失败",
                                type: "error",
                            });
                        }
                    })
                }
            });
        },
    },
    mounted() {
        GetCurrencyServiceModelList({}).then((res) => {
            this.currencyList = toSelectOptions(res.data.response, "currencyValue", "currencyName");
        });
    },
};
</script>

<style lang="less" scoped>
.addServicesFormLine {
    display: flex;
    text-align: left;
    white-space: nowrap;

    >div {
        width: 33.333%;
    }


    .el-date-editor.el-input {
        width: 100%;
    }
}
.noMarginBottom {
    margin-bottom: 0 !important;
}
</style>
  
  